import {SiteClicksData} from "../types/yandex-data-check.types";

export const defaultSiteSlicksData: SiteClicksData = {
  siteClicks: 0
}
